import { useState, useEffect } from "react";

export function useUserLocation() {
  const [userLocation, setUserLocation] = useState(null);
  const [locationError, setLocationError] = useState(null);
  const [loading, setLoading] = useState(true);

  // Fetch user location on mount
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          setUserLocation({
            lat: pos.coords.latitude,
            lng: pos.coords.longitude,
          });
          setLoading(false);
        },
        (err) => {
          console.error("Error getting location:", err);
          setLocationError("Location access denied. Please enable it.");
          setLoading(false);
        },
      );
    } else {
      setLocationError("Geolocation is not supported in this browser.");
      setLoading(false);
    }
  }, []);

  return { userLocation, locationError, loading };
}